import { Plugin } from '..';
import { normalizeAlertBannerDismissedRewrite } from 'lib/middleware/plugins/alert-banner-dismissed';

class AlertBannerDismissedPlugin implements Plugin {
  exec(path: string) {
    // Remove alert banner dismissed rewrite segment from the path
    return normalizeAlertBannerDismissedRewrite(path);
  }
}

export const alertBannerDismissedPlugin = new AlertBannerDismissedPlugin();
